import { PHOTOS } from "@/assets/photos";
import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";

import { PageHero, Section } from "@/components/site/section";
import { FixtureCard, dateUtils } from "@/components/site/cards";
import { fixturesQuery } from "@/lib/site-queries";

export const Route = createFileRoute("/national-team/fixtures")({
  head: () => ({
    meta: [
      { title: "Argentina Fixtures | Argentinian.Soccer" },
      { name: "description", content: "All upcoming and recent fixtures for the Argentina National Team." },
      { property: "og:title", content: "Argentina Fixtures | Argentinian.Soccer" },
      { property: "og:url", content: "/national-team/fixtures" },
    ],
    links: [{ rel: "canonical", href: "/national-team/fixtures" }],
  }),
  loader: ({ context }) => context.queryClient.ensureQueryData(fixturesQuery("senior", 30)),
  component: FixturesPage,
});

function FixturesPage() {
  const { data } = useSuspenseQuery(fixturesQuery("senior", 30));
  const upcoming = data.filter((f) => f.argentina_score === null || f.opponent_score === null);
  const past = data.filter((f) => f.argentina_score !== null && f.opponent_score !== null);
  const next = upcoming[0];

  return (
    <>
      <PageHero eyebrow="National Team" title="Argentina Fixtures" image={PHOTOS.messiCelebration} />
      {next && (
        <Section id="argentina-next-match" eyebrow="Argentina Next Match" title="Argentina Next Match">
          <div className="rounded-xl border border-border bg-card p-6">
            <p className="font-condensed text-sm uppercase tracking-widest text-muted-foreground">
              vs <span className="font-bold text-navy">{next.opponent}</span> · {next.competition}
            </p>
            <p className="mt-2 font-display text-4xl text-navy">
              {dateUtils.fmtLong(next.kickoff)}
            </p>
            <p className="mt-1 font-condensed text-sm uppercase tracking-widest text-primary">
              Kick-off · {dateUtils.fmtTime(next.kickoff)} UTC
            </p>
          </div>
        </Section>
      )}

      <Section title="Upcoming">
        <div className="grid gap-5 md:grid-cols-2">
          {upcoming.map((f) => <FixtureCard key={f.id} fixture={f} />)}
        </div>
      </Section>

      <Section title="Results">
        <div className="grid gap-5 md:grid-cols-2">
          {past.map((f) => <FixtureCard key={f.id} fixture={f} />)}
        </div>
      </Section>
    </>
  );
}
